import {GetHealthSpecialtyDescriptionParams} from 'domain/usecases/private/booking-flow/health/get-health-specialty-description';
import {makeGetHealthSpecialtyDescription} from 'main/factories/usecases/private/booking-flow/remote-health-booking/get-health-specialty-description-factory';

async function getHealthSpecialtyDescription(params: GetHealthSpecialtyDescriptionParams) {
	const specialtyDescription = await makeGetHealthSpecialtyDescription().get(params);

	return specialtyDescription;
}

export {getHealthSpecialtyDescription};
